import { render } from "./ListingPerLingua.vue?vue&type=template&id=5722ac78"
import script from "./ListingPerLingua.vue?vue&type=script&lang=js"
export * from "./ListingPerLingua.vue?vue&type=script&lang=js"

import "./ListingPerLingua.vue?vue&type=style&index=0&id=5722ac78&lang=css"

import exportComponent from "C:\\Users\\fr201\\Informatique\\annuario\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__